module.exports = __webpack_public_path__ + "img/icon1.988d79ed.svg";